import axios from "axios";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import { useLocation, useNavigate } from "react-router-dom";
import { RoleEditSchema } from "../../../ValidationSchema";

// const colourStyles = {
//   control: (styles) => ({
//     ...styles,
//     border: "1px solid #bfc9d4",
//     boxShadow: "#000 !important",
//     borderRadius: "6px",
//     padding: "4px",
//     "&:hover": {
//       border: "1px solid #bfc9d4",
//     },
//   }),
//   multiValue: (styles) => {
//     return {
//       ...styles,
//       backgroundColor: "#606060",
//     };
//   },
//   multiValueLabel: (styles) => ({
//     ...styles,
//     color: "#fff",
//   }),
//   multiValueRemove: (styles, { data }) => ({
//     ...styles,
//     color: "#000",
//     "& > svg": {
//       backgroundColor: "#fff",
//       borderRadius: "10px",
//       marginLeft: "2px",
//       marginRight: "2px",
//     },
//     ":hover": {
//       backgroundColor: data.color,
//       color: data.color,
//     },
//   }),
//   option: (styles, { data }) => {
//     return {
//       ...styles,
//       backgroundColor: "white",
//       color: "#000",
//       ":hover": {
//         backgroundColor: "#f5f5f5",
//       },
//     };
//   },
// };

const AssignCodeEdit = () => {
  const location = useLocation();
  const Navigate = useNavigate();
  const [initialValues, setInitialValues] = useState({
    name: "",
  });

  const GetUserData = () => {
    axios
      .get(
        `${process.env.REACT_APP_URL}/admin/product/edit-get?id=${location?.state?.id}`,
        {
          headers: {
            "j-authorization": ` ${localStorage.getItem("Token")}`,
          },
        }
      )
      .then((res) => {
        if (res.status === 200) {
          setInitialValues({
            name: res?.data?.data?.name,
          });
        }
      })
      .catch((err) => {

        const MSG = ["Token not found.", "Invalid token.", "Unauthorized."];
        const STATUS = [401, 403];
        if (
          STATUS.includes(err.response.status) ||
          MSG.includes(err.response.data.msg)
        ) {
          localStorage.clear();
          Navigate("/admin/login");
        } else {
          toast.error(err?.response?.data?.msg);
        }
      });
  };

  const AddRoom = useFormik({
    initialValues,
    enableReinitialize: true,
    validationSchema: RoleEditSchema,

    onSubmit: (values, action) => {
      let data = {
        id: location?.state?.id,
        name: values.name,
      };
      axios
        .post(`${process.env.REACT_APP_URL}/admin/product/store`, data, {
          headers: {
            "j-authorization": ` ${localStorage.getItem("Token")}`,
          },
        })
        .then((res) => {
          if (res.status === 200) {
            toast.success(`Role Updated Successfully`);
            Navigate("/admin/role", { state: res?.data?.msg });
          }
        })
        .catch((err) => {
          toast.error(err.response.data.msg);
        });
    },
  });

  //   const UserRole = () => {
  //     axios
  //       .get(`${process.env.REACT_APP_URL}/common/roles`)
  //       .then((res) => {
  //         setUserRole(res.data.roles);
  //       })
  //       .catch((err) => {
  //         if (err.response.data.message === "Unauthorized!") {
  //           Navigate("/admin/login");
  //         }
  //       });
  //   };

  useEffect(() => {
    GetUserData();
  }, []);

  return (
    <div className="al">
      <Toaster position="top-center" reverseOrder={false} />

      <div className="al-head">
        <div>
          <h1 className="al-title">Edit Assign Order</h1>
          <p className="al-sub">Update this record.</p>
        </div>
        <div className="al-head__actions">
          <button type="button" className="al-btn" onClick={() => Navigate(-1)}>
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6" /></svg>
            Back
          </button>
        </div>
      </div>

      <form onSubmit={AddRoom.handleSubmit}>
        <div className="al-card">
          <div className="al-cardhead">
            <div className="al-cardhead__icon"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" /><rect x="8" y="2" width="8" height="4" rx="1" /></svg></div>
            <h3 className="al-cardhead__title">Details</h3>
          </div>
          <div className="al-form">
            <div className="al-form__full">
              <label className="al-label">Name</label>
              <input className="al-input" type="text" placeholder="Enter Name"
                value={AddRoom.values.name} onChange={AddRoom.handleChange} onBlur={AddRoom.handleBlur} name="name" />
              {AddRoom.errors.name && AddRoom.touched.name ? (
                <div className="al-err">{AddRoom.errors.name}</div>
              ) : null}
            </div>
          </div>
          <div className="al-actionbar">
            <button type="button" className="al-btn" onClick={() => Navigate(-1)}>Cancel</button>
            <button type="submit" className="al-btn al-btn--primary">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12" /></svg>
              Save Changes
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default AssignCodeEdit;
